import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/api/blog')
      .then(res => {
        if (!cancelled) {
          setPosts(res.data.posts || []);
          setError(null);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err.response?.data?.error || 'Failed to load blog');
          setPosts([]);
        }
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Blog</h1>
          <Link
            to="/blog/submit"
            className="text-sm text-blue-600 hover:text-blue-800 font-medium"
          >
            Submit a post
          </Link>
        </div>

        {loading && (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
          </div>
        )}

        {error && (
          <p className="text-red-600 bg-red-50 p-4 rounded-lg">{error}</p>
        )}

        {!loading && !error && posts.length === 0 && (
          <p className="text-gray-500">No posts yet. Check back soon or submit one!</p>
        )}

        {!loading && !error && posts.length > 0 && (
          <ul className="space-y-4">
            {posts.map(post => (
              <li key={post._id}>
                <Link
                  to={`/blog/post/${post.slug}`}
                  className="block bg-white rounded-lg border border-gray-200 p-4 hover:border-blue-300 hover:shadow-sm transition"
                >
                  <h2 className="text-lg font-semibold text-gray-900">{post.title}</h2>
                  <p className="text-sm text-gray-500 mt-1">
                    {post.authorName}
                    {post.publishedAt && (
                      <span className="ml-2">
                        · {new Date(post.publishedAt).toLocaleDateString()}
                      </span>
                    )}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default BlogList;
